import { type UseModalState } from "@clipboard-health/ui-react";
import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dialog } from "@src/appV2/redesign/components/Dialog";
import { Text } from "@src/appV2/redesign/components/Text";
import { logout } from "@src/modules/session";

interface LogoutConfirmationDialogProps {
  modalState: UseModalState;
}

export function LogoutConfirmationDialog(props: LogoutConfirmationDialogProps) {
  const { modalState } = props;

  function handleLogout() {
    modalState.closeModal();
    logout();
  }

  return (
    <Dialog
      showCloseButton
      modalState={modalState}
      title="Confirm Logout"
      footerContent={
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingX: theme.spacing(5),
            paddingY: theme.spacing(3),
          })}
        >
          <Button variant="outlined" onClick={modalState.closeModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      }
    >
      <Stack alignItems="center" spacing={3}>
        <Stack alignItems="center" spacing={1}>
          <Text>Are you sure you want to logout?</Text>
          <Text variant="body2" sx={(theme) => ({ color: theme.palette.text?.secondary })}>
            You will need to sign in again to access your account.
          </Text>
        </Stack>
      </Stack>
    </Dialog>
  );
}
